import React, { useEffect, useMemo, useState } from 'react';
import { iframeService, roundInfoStore, useTranslation } from '@pascal/pascal-core';
import RectangleTable from '../components/rectangleTable';
import OvalTable from '../components/ovalTable';

import WinNumbers from '../components/winNumbers';
import { betShopStore } from '../store/betShopStore';
import { observer } from 'mobx-react-lite';
import { winningAmountStore } from '../store/winningAmountStore';
import { winNumbersColor } from '../helpers/winNumbersColor';
import PayoutBetShop from './betShop/payoutBetShop';
import HotNumbersBetShop from './betShop/hotNumbersBetShop';
import Slider from './betShop/slider';
import SnakesBetType from '../components/snakesBetType';
import { roundTimeStore } from '../store/roundTimeStore';
import moment from 'moment/moment';
import { limitsTranslationKeys } from '../enums/limitsTranslationKeys';
import './../assets/styles/betshop-roulette.scss';
import {BetShopHeader} from "../components/betShopHeader";

const BetShopGame = observer(() => {
  const { betShopStatistic, isShowStatistic } = betShopStore;
  const { winNumber } = winningAmountStore;
  const { roundId } = roundInfoStore;
  const t = useTranslation();
  const [activeLastRound] = useState(100);
  const winNumbersResult = useMemo(() => {
    return winNumbersColor(winNumber);
  }, [winNumber]);
  useEffect(() => {
    iframeService.sendLoadedState();
  }, []);
  const { ROUND_ID } = limitsTranslationKeys;
  return (
    <div className='roulette-betshop-wrapper'>
      {/*<span className="roulette-betshop-image" />*/}
      {winNumbersResult && !isShowStatistic ? (
        <WinNumbers isBetShop={true} winNumbersResult={winNumbersResult} />
      ) : null}
      <canvas id={'roulette-canvas'} width={1920} height={1080}></canvas>
      {isShowStatistic ? (
        <div className='roulette-betshop-inner'>
          <BetShopHeader t={t}/>
          {/*<img src={Logo} className='roulette-betshop-logo' alt='' />*/}
          {/*<span className='dw-betshop-result-timer'>{moment.utc(roundTimeStore.time * 1000).format('mm:ss')}</span>*/}
          {/*<span className='dw-betshop-result-timer-label'>{`${t(ROUND_ID)}: ${roundId} `}</span>*/}
          <Slider betShopStatistic={betShopStatistic} activeLastRound={activeLastRound} t={t} />
          <HotNumbersBetShop betShopStatistic={betShopStatistic} activeLastRound={activeLastRound} />
          <PayoutBetShop t={t} />
          <div className='roulette-betshop-square-table'>
            <RectangleTable />
          </div>
          <div className='roulette-betshop-oval-table'>
            <OvalTable isShowNeighbors={false} />
            <SnakesBetType isBetShop={true} />
          </div>
        </div>
      ) : null}
    </div>
  );
});
export default BetShopGame;
